import React from "react";
import { Link } from "react-router-dom";
import { Play, Heart } from "lucide-react";

/** Grid of vertical video cards → opens /reels?start=id */
export default function ReelGrid({ reels, testidPrefix = "reel-card" }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2" data-testid={`${testidPrefix}-grid`}>
      {reels.map((v) => (
        <Link key={v.post_id} to={`/reels?start=${v.post_id}`} className="relative aspect-[9/16] rounded-xl overflow-hidden bg-black group" data-testid={`${testidPrefix}-${v.post_id}`}>
          {v.cover_url
            ? <img src={v.cover_url} alt="" className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" />
            : <video src={v.video_url} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 transition-opacity" muted playsInline preload="metadata" />}
          <div className="absolute inset-0 flex items-center justify-center"><Play className="w-8 h-8 text-white drop-shadow" /></div>
          <div className="absolute bottom-0 inset-x-0 p-2 bg-gradient-to-t from-black/80 to-transparent text-white text-[11px]">
            <div className="truncate font-semibold">{v.author_name}</div>
            <div className="flex items-center gap-1 text-white/80"><Heart className="w-3 h-3" /> {(v.likes || []).length}</div>
          </div>
        </Link>
      ))}
    </div>
  );
}
